import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Block, ExternalLink, Heading, IconPdf } from 'suomifi-ui-components'
import { isPaymentFreeOfCharge } from 'todistukset-common/src/vtj/price.util'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import { ParagraphWithNewlines } from 'todistukset-ui/src/vtj/components/order-wizard/CommonFormComponents.sc'
import {
  StyledLinkList,
  StyledLinkListItem,
} from 'todistukset-ui/src/vtj/components/order-wizard/OrderCompleteStep.sc'
import { getOrder } from 'todistukset-ui/src/vtj/components/order-wizard/OrderCompleteStep.util'
import { useStore } from 'todistukset-ui/src/vtj/stores/store.util'

const ReceiptDownload: React.FC = observer(() => {
  const { t } = useTranslation()
  const { paymentId } = useParams()
  const store = useStore()

  const order =
    getOrder(store, paymentId) ??
    store.uaetOrders.find(
      (uaetOrder) => uaetOrder.form.paymentId === Number(paymentId)
    )

  if (!paymentId || !order?.payment || isPaymentFreeOfCharge(order.payment)) {
    return null
  }

  return (
    <Block variant="section">
      <Heading variant="h3">
        <LocalizedString stringKey="orderWizardOrderCompleteStepReceiptTitle" />
      </Heading>
      <ParagraphWithNewlines>
        <LocalizedString stringKey="orderWizardOrderCompleteStepReceiptDescription" />
      </ParagraphWithNewlines>
      <StyledLinkList ariaLabelledBy="orderWizardOrderCompleteStepReceiptTitle">
        <StyledLinkListItem icon={<IconPdf />}>
          <ExternalLink
            data-test-id="receipt-download-link"
            href={`/api/restricted/todistukset/order-receipt/${paymentId}`}
            labelNewWindow={t('opensInNewWindow')}
            toNewWindow
          >
            {`${t('orderWizardOrderCompleteStepReceiptTitle')}.pdf`}
          </ExternalLink>
        </StyledLinkListItem>
      </StyledLinkList>
    </Block>
  )
})

export default ReceiptDownload
